import { InfoArea } from "../styles";
import React, { useEffect } from "react";
import { ESubInfo } from "./types";
import { useMediaQuery } from "react-responsive/dist/react-responsive";
import { PrincipalInfoSection } from "./panels/PrincipalInfoSection";
import { BidInfoSection } from "./panels/BidInfoSection";
import { PenaltiesInfoSection } from "./panels/PenaltiesInfoSection";
import { BondInfoSection } from "./panels/BondInfoSection";
import { JobCostBreakdownInfoSection } from "./panels/JobCostBreakdownSection";
import { ObligeeInfoSection } from "./panels/ObligeeInfoSection";
import { SubcontractorInfoSection } from "./panels/SubcontractorInfoSection";
import { RemarksSection } from "./panels/RemarksSection";

type BondDetailsProps = {
  step: number;
  esubData: ESubInfo;
  setEsubData: (field: string, value: string) => void;
  handleNext: (handleGenericGenerate?: unknown, getPDF?: unknown) => void;
  panel: number;
  setPanel: (panel: number) => void;
  setIsLastPanel: (isLastPanel: boolean) => void;
  setPreviousStepPanel: (prevStepPanel: number) => void;
  accountId: number;
};

export const BondDetails = ({
  step,
  esubData,
  setEsubData,
  handleNext,
  panel,
  setPanel,
  setIsLastPanel,
  setPreviousStepPanel,
  accountId,
}: BondDetailsProps) => {
  const isMobile = useMediaQuery({ maxWidth: 960 });

  // Log esubData when component mounts or data changes
  useEffect(() => {
    console.log("[Bond Details] Component mounted/updated - esubData:", esubData);
  }, [esubData]);

  useEffect(() => {
    if (accountId) {
      setEsubData("bond_details.account_id", accountId);
    }
  }, [accountId]);

  return (
    <>
      <InfoArea
        isMobile={isMobile}
        width="650px"
        isColumn={true}
        marginTop="0px"
      >
        {panel === 1 && (
          <PrincipalInfoSection
            esubData={esubData}
            setESubData={setEsubData}
            isMobile={isMobile}
            handleNext={handleNext}
            panel={panel}
            setIsLastPanel={setIsLastPanel}
            setPanel={setPanel}
            setPreviousStepPanel={setPreviousStepPanel}
          />
        )}

        {panel === 2 && (
          <ObligeeInfoSection
            esubData={esubData}
            setESubData={setEsubData}
            isMobile={isMobile}
            handleNext={handleNext}
            panel={panel}
            setIsLastPanel={setIsLastPanel}
            setPanel={setPanel}
            setPreviousStepPanel={setPreviousStepPanel}
          />
        )}

        {panel === 3 && (
          <BidInfoSection
            esubData={esubData}
            setESubData={setEsubData}
            isMobile={isMobile}
            handleNext={handleNext}
            panel={panel}
            setIsLastPanel={setIsLastPanel}
            setPanel={setPanel}
            setPreviousStepPanel={setPreviousStepPanel}
          />
        )}

        {panel === 4 && (
          <PenaltiesInfoSection
            esubData={esubData}
            setESubData={setEsubData}
            isMobile={isMobile}
            handleNext={handleNext}
            panel={panel}
            setIsLastPanel={setIsLastPanel}
            setPanel={setPanel}
            setPreviousStepPanel={setPreviousStepPanel}
          />
        )}

        {panel === 5 && (
          <BondInfoSection
            esubData={esubData}
            setESubData={setEsubData}
            isMobile={isMobile}
            handleNext={handleNext}
            panel={panel}
            setIsLastPanel={setIsLastPanel}
            setPanel={setPanel}
            setPreviousStepPanel={setPreviousStepPanel}
          />
        )}

        {panel === 6 && (
          <JobCostBreakdownInfoSection
            esubData={esubData}
            setESubData={setEsubData}
            isMobile={isMobile}
            handleNext={handleNext}
            panel={panel}
            setIsLastPanel={setIsLastPanel}
            setPanel={setPanel}
            setPreviousStepPanel={setPreviousStepPanel}
          />
        )}

        {panel === 7 && (
          <SubcontractorInfoSection
            esubData={esubData}
            setESubData={setEsubData}
            isMobile={isMobile}
            handleNext={handleNext}
            panel={panel}
            setIsLastPanel={setIsLastPanel}
            setPanel={setPanel}
            setPreviousStepPanel={setPreviousStepPanel}
          />
        )}

        {panel === 8 && (
          <RemarksSection
            esubData={esubData}
            setESubData={setEsubData}
            isMobile={isMobile}
            handleNext={handleNext}
            panel={panel}
            setIsLastPanel={setIsLastPanel}
            setPanel={setPanel}
            setPreviousStepPanel={setPreviousStepPanel}
          />
        )}
      </InfoArea>
    </>
  );
};
